// extracted by mini-css-extract-plugin
export default {"root":"x5rgCuoHeJ_ZOec6BWA6"};